<template>
  <a-modal title="选择项目"
           class="select-customer-modal"
           width="70%"
           :visible="visible"
           :getContainer="false"
           @ok="handleOk"
           @cancel="closeModal">
      <div class="seachList">
        <div class="item">
          <span class="name">客户名称</span>
          <a-input class="seachs"  v-model="search.company" placeholder="客户名称" @keydown.enter.native="searchKey"/>
        </div>
        <div class="item">
          <span class="name">合同编号</span>
          <a-input class="seachs"  v-model="search.erp_contract_number" placeholder="合同编号" @keydown.enter.native="searchKey"/>
        </div>
        <div class="seachBtnBox">
          <a-button type="primary" class="seachBtn" @click="getList(1)"> 搜索</a-button>
          <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
        </div>
      </div>

       <a-table :columns="columns" :data-source="tableList" :pagination="pagination" rowKey="id" :loading="loading"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" ></a-table>
  </a-modal>
</template>

<script>
import API from "@/views/KshTemplateManagement/TemplateListManagement/api";
import columns from "../config/selectCustomerColumns";

export default {
  name: 'selectCustomerModal',
  props: ['visible','a_ksh_template_id'],
  data() {
    return {
      search: {
        company: '',
        erp_contract_number: '',
        page: 1,
      },
      loading: false,
      columns: columns,
      tableList: [],
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      selectedRowKeys: [],
    };
  },
  watch:{
    visible: function (a) {
      if (a) {
        this.getList(1);
      }
    },
  },
  mounted(){
  },
  methods: {
    closeModal() {
      this.visible = false;
      this.selectedRowKeys = [];
      this.search = {
        company: '',
        erp_contract_number: '',
        page: 1,
      }
    },
    resetSeach() {
      this.search = {
        company: '',
        erp_contract_number: '',
        page: 1,
      }
      this.getList(1);
    },
    handleOk() {
      if(this.selectedRowKeys.length < 1) {
        this.$message.destroy()
        this.$message.warning('请选择客户');
        return false
      }
      if(this.selectedRowKeys.length > 1) {
        this.$message.destroy()
        this.$message.warning('只能选择1条数据');
        return false
      }
      API.service.SELECT_TEMPLATE({
        a_ksh_template_id: this.a_ksh_template_id,
        a_customer_id: this.selectedRowKeys[0]
      }).then(res => {
         if(res.data.code == 200) {
           this.$message.success(res.data.msg);
           this.$emit('handleSubmit');
         }
      })
    },
    getList(page) {
      this.search.page = page || 1;
      this.loading = true
      API.service.TEMPLATE_SELECT_CUSTOMER(this.search).then(res => {
        this.tableList = res.data.data.list.data
        this.pagination.total=res.data.data.list.total
        this.pagination.pageSize=res.data.data.list.per_page
        this.pagination.current=res.data.data.list.current_page
        this.loading = false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    searchKey(){
      if(event.keyCode == 13){
        this.getList(1)
      }
    }
  },
}
</script>

<style scoped>
  .seachList {
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .name {
        margin-right: 20px;
      }
      .ant-input {
        flex: 1;
      }
    }
  }
  .seachBtnBox {
    .ant-btn+.ant-btn {
      margin-left: 10px;
    }
  }
  .select-customer-modal {
    .ant-modal-footer{
      div {
        text-align: center;
      }
    }
  }
</style>